import React from 'react';

export const AdminAnalytics: React.FC = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-2xl font-bold text-foreground mb-2">
        Analytics Dashboard
      </h1>
      <p className="text-muted-foreground">
        Analytics dashboard will be implemented here
      </p>
    </div>
  );
};